import { defineSlotRecipe } from "@chakra-ui/react/styled-system";
import { tagAnatomy } from "@chakra-ui/react/anatomy";
import { interactiveTransition } from "./_shared";

export default defineSlotRecipe({
  slots: tagAnatomy.keys(),
  base: {
    root: {
      ...interactiveTransition,
    },
  },
});
